import { useEffect as t, useState as e, useCallback as n } from "react";
function r(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function a(t, e) {
  return function (t) {
    if (Array.isArray(t)) return t;
  }(t) || function (t, e) {
    var n = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
    if (null == n) return;
    var r,
      a,
      o = [],
      i = !0,
      l = !1;
    try {
      for (n = n.call(t); !(i = (r = n.next()).done) && (o.push(r.value), !e || o.length !== e); i = !0) {
        ;
      }
    } catch (t) {
      l = !0, a = t;
    } finally {
      try {
        i || null == n.return || n.return();
      } finally {
        if (l) throw a;
      }
    }
    return o;
  }(t, e) || function (t, e) {
    if (!t) return;
    if ("string" == typeof t) return o(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    "Object" === n && t.constructor && (n = t.constructor.name);
    if ("Map" === n || "Set" === n) return Array.from(t);
    if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return o(t, e);
  }(t, e) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function o(t, e) {
  (null == e || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++) {
    r[n] = t[n];
  }
  return r;
}
var i = new (function () {
    return t = function t() {
      var e = this;
      !function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, t), this.onReady = function (t) {
        return e.isReady ? t() : (window.bvCallback = function (n) {
          n.api.ready().then(function () {
            t(), e.isReady = !0;
          }).catch(function (t) {
            console.error("BV api loading error", t);
          });
        }, null);
      }, this.trackCatalogUpdate = function (t, e) {
        window.bvDCC = {
          catalogData: {
            locale: e,
            catalogProducts: t
          }
        }, t.forEach(function (t) {
          window.BV.pixel.trackEvent("CatalogUpdate", {
            type: "Product",
            locale: e,
            catalogProducts: [t]
          });
        });
      }, this.trackConversion = function (t) {
        var e = t.type,
          n = t.label,
          r = t.value;
        window.BV.pixel.trackConversion({
          type: e,
          label: n,
          value: r
        });
      }, this.isReady = !1;
    }, e && r(t.prototype, e), n && r(t, n), Object.defineProperty(t, "prototype", {
      writable: !1
    }), t;
    var t, e, n;
  }())(),
  l = [];
var c = function c(r) {
  !function (r) {
    var o = a(e(), 2),
      i = o[0],
      c = o[1],
      u = a(e(), 2),
      f = u[0],
      s = u[1],
      d = function d() {
        c(!0), s(!1);
      },
      y = function y() {
        c(!1), s(!0);
      },
      p = n(function () {
        l.push(r);
        var t = document.createElement("script");
        return t.src = r, t.async = !0, t.addEventListener("load", d), t.addEventListener("error", y), document.body.appendChild(t), function () {
          t.removeEventListener("load", d), t.removeEventListener("error", y);
        };
      }, [r]);
    t(function () {
      l.includes(r) ? d() : p();
    }, [p, r]);
  }(r);
  return {
    trackCatalogUpdate: n(function (t, e) {
      i.onReady(function () {
        i.trackCatalogUpdate(t, e);
      });
    }, []),
    trackConversion: n(function (_ref) {
      var t = _ref.type,
        e = _ref.label,
        n = _ref.value;
      i.onReady(function () {
        i.trackConversion({
          type: t,
          label: e,
          value: n
        });
      });
    }, [])
  };
};
export { c as useBazaarVoice };